import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import GoalButton from "layouts/goals/components/GoalButton";

function ArchiveEmployeeModal({ open, onClose, onConfirm, employeeName, isSubmitting }) {
  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>Archive employee?</DialogTitle>
      <DialogContent>
        <SuiTypography variant="button" color="text" display="block">
          Are you sure you want to archive &quot;{employeeName}&quot;? They will be taken off the
          dashboard and reports and their reporting lines will be removed. Their record stays on
          this page, and they are added back if they check in again.
        </SuiTypography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton
          variant="danger"
          icon="person_remove"
          loading={isSubmitting}
          onClick={onConfirm}
        >
          Archive
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default ArchiveEmployeeModal;
